import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon } from "../index";

const styles = {
	errorPopup: {},
};

const AliquotsTab = ({ t, disabled, aliquotsErrors, aliquotStatus, missingVolumeTubes }) => {
	return (
		<Popup
			position="bottom right"
			disabled={!aliquotsErrors || aliquotStatus || disabled}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<Icon name="lab" size="small" /> {t("subMenu.aliquots")}
					{!disabled && (aliquotStatus ? <CheckIcon /> : <WarningIcon />)}
				</span>
			}
		>
			<Popup.Header>{t("subMenu.aliquotsNotPreleved")}</Popup.Header>
			<Popup.Content>
				<List bulleted>
					{aliquotsErrors.map((error, index) => (
						<List.Item key={`tube-${index}`}>{error}</List.Item>
					))}
				</List>
				{missingVolumeTubes && <div style={{ marginTop: 5 }}>{t("subMenu.aliquotsWithInsuffisantVolume")}</div>}
			</Popup.Content>
		</Popup>
	);
};

export default AliquotsTab;
